import { render, staticRenderFns } from "./factura.vue?vue&type=template&id=5ef953f6&scoped=true&"
import script from "./factura.vue?vue&type=script&lang=js&"
export * from "./factura.vue?vue&type=script&lang=js&"
import style0 from "./factura.vue?vue&type=style&index=0&id=5ef953f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef953f6",
  null
  
)

export default component.exports